import { WARRANTY_TYPE_OPTIONS } from '@/view/pages/products/utils/constants';
import { convertToNumber, removeAccents } from '@/utils/common';
import ApiService from '@/core/services/api.service';

const productMixin = {
  data() {
    return {
      // Bảo hành
      // Loại bảo hành
      selectedWarrantyType: null,
      warrantyTypeList: WARRANTY_TYPE_OPTIONS,
      isShowErrorSelectedWarrantyType: false,

      // Số lần sử dụng tối đa
      maxWarrantyUsage: null,
      isUnlimitedWarrantyUsage: false,
      isDisabledUnlimitedWarrantyUsage: false,
      isShowErrorWarrantyUsage: false,

      isShowErrorWarrantyMonthNo: false,

      selectedWarrantyBenefitPolicyId: null,
      isShowErrorWarrantyBenefitPolicy: false,
      searchWarrantyBenefitPolicyName: '',
      listWarrantyBenefitPolicy: [],
      warrantyBenefitPolicyOptions: [],
      filteredWarrantyBenefitPolicyOptions: [],
      page: 1,
      limit: 1000,
      size: 1000,
    };
  },
  watch: {
    selectedWarrantyType(value) {
      if (value) this.isShowErrorSelectedWarrantyType = false;
    },
    maxWarrantyUsage(value) {
      if (value) this.isShowErrorWarrantyUsage = false;
    },
    warrantyMonthNo(value) {
      if (value) this.isShowErrorWarrantyMonthNo = false;
    },
    isUnlimitedWarrantyUsage(value) {
      if (value) this.isShowErrorWarrantyUsage = false;
    },
    selectedWarrantyBenefitPolicyId(value) {
      if (value) this.isShowErrorWarrantyBenefitPolicy = false;
    },
  },
  created() {
    this.fetchWarrantyBenefitPolicies();
  },
  methods: {
    fetchWarrantyBenefitPolicies() {
      this.listWarrantyBenefitPolicy = [];
      const params = {
        page: this.page,
        limit: this.size,
        name: '',
      };
      ApiService.query('warranty-benefit-policy', { params }).then(
        (response) => {
          response.data.data.result.forEach((item) => {
            const warrantyBenefitPolicy = {
              id: item.id,
              name: item.name,
            };
            this.listWarrantyBenefitPolicy.push(warrantyBenefitPolicy);
          });
          this.warrantyBenefitPolicyOptions = response.data.data.result;
          this.filteredWarrantyBenefitPolicyOptions = [
            ...this.listWarrantyBenefitPolicy,
          ];
        },
      );
    },
    onInputWarrantyBenefitPolicyChange(text) {
      this.searchWarrantyBenefitPolicyName = text;

      const filteredData = this.warrantyBenefitPolicyOptions
        .filter((item) => {
          return (
            removeAccents(item.name)
              .toLowerCase()
              .indexOf(removeAccents(text.toLowerCase())) > -1
          );
        })
        .slice(0, this.limit);

      this.filteredWarrantyBenefitPolicyOptions = [...filteredData];
      if (this.searchWarrantyBenefitPolicyName === '') {
        this.filteredWarrantyBenefitPolicyOptions = [
          ...this.warrantyBenefitPolicyOptions,
        ];
      }
      if (!this.searchWarrantyBenefitPolicyName) {
        this.selectedWarrantyBenefitPolicyId = null;
        this.isShowErrorWarrantyBenefitPolicy = false;
      }
    },

    handleUnlimitedWarrantyUsageChange(value) {
      this.isDisabledUnlimitedWarrantyUsage = value;
      this.isUnlimitedWarrantyUsage = value;
      this.maxWarrantyUsage = null;
      if (this.isUnlimitedWarrantyUsage) {
        this.isShowErrorWarrantyUsage = false;
      }
    },
    validateProductWarranty() {
      let result = true;

      if (!this.selectedWarrantyBenefitPolicyId) {
        this.isShowErrorWarrantyBenefitPolicy = true;
      }

      if (!this.selectedWarrantyType) {
        this.isShowErrorSelectedWarrantyType = true;
        result = false;
      }

      if (isNaN(Number(this.selectedWarrantyType))) {
        this.isShowErrorSelectedWarrantyType = true;
        result = false;
      }

      if (!this.warrantyMonthNo) {
        this.isShowErrorWarrantyMonthNo = true;
        result = false;
      }

      if (this.warrantyMonthNo && isNaN(Number(this.warrantyMonthNo))) {
        this.isShowErrorWarrantyMonthNo = true;
        result = false;
      }

      if (!this.maxWarrantyUsage) {
        if (!this.isUnlimitedWarrantyUsage) {
          this.isShowErrorWarrantyUsage = true;
          result = false;
        }
      }

      if (this.maxWarrantyUsage) {
        if (isNaN(Number(this.maxWarrantyUsage))) {
          this.isShowErrorWarrantyUsage = true;
          result = false;
        }
      }

      return result;
    },
    mapProductWarrantyToProductPayload() {
      return {
        warrantyType: convertToNumber({
          value: this.selectedWarrantyType,
          defaultValue: 0,
        }),
        maxWarrantyUsage: convertToNumber({
          value: this.maxWarrantyUsage,
          defaultValue: 0,
        }),
        isUnlimitedWarrantyUsage: Boolean(this.isUnlimitedWarrantyUsage),
        warrantyBenefitPolicyId: convertToNumber({
          value: this.selectedWarrantyBenefitPolicyId,
          defaultValue: 0,
        }),
      };
    },
    handleChangeWarrantyMonthNo(value) {
      if (value) this.isShowErrorWarrantyMonthNo = false;
    },
    handleResetProductWarranty() {
      this.selectedWarrantyType = null;
      this.isShowErrorSelectedWarrantyType = false;

      this.maxWarrantyUsage = null;
      this.isUnlimitedWarrantyUsage = false;
      this.isDisabledUnlimitedWarrantyUsage = false;
      this.isShowErrorWarrantyUsage = false;

      this.isShowErrorWarrantyMonthNo = false;

      this.searchWarrantyBenefitPolicyName = '';
      this.selectedWarrantyBenefitPolicyId = null;
      this.isShowErrorWarrantyBenefitPolicy = false;
    },
  },
};
export default productMixin;
